import { env } from "./env";

export const hotelConfig = {
    baseURL: env.FLIGHT_API_BASE_URL,
    ipAdress: env.REACT_APP_IP_ADDRESS,
    hotelUsername: env.REACT_APP_HOTEL_USERNAME,
    hotelPassword: env.REACT_APP_HOTEL_PASSWORD,
};